import { GermanLabExportData, GermanPosition } from "./types";

function escapeXml(str: string | number): string {
	if (typeof str === "number") return str.toString();
	return str
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&apos;");
}

function generatePositionXml(position: GermanPosition): string {
	const nummerAttr =
		position.art === "BEL" && position.nummer
			? ` Nummer="${escapeXml(position.nummer)}"`
			: "";

	return `      <Position Art="${escapeXml(
		position.art
	)}"${nummerAttr} Beschreibung="${escapeXml(
		position.beschreibung
	)}" Einzelpreis="${position.einzelpreis}" Menge="${position.menge}"/>`;
}

export function generateGermanLabXml(data: GermanLabExportData): string {
	const { rechnung } = data;

	const mwstGruppenXml = rechnung.mwstGruppen
		.map((gruppe, index) => {
			const positionenXml = gruppe.positionen
				.map(generatePositionXml)
				.join("\n");

			return `    <MWST-Gruppe Zwischensumme_netto="${gruppe.zwischensumme_netto}" Mehrwertsteuersatz="${gruppe.mehrwertsteuersatz}" Mehrwertsteuerbetrag="${gruppe.mehrwertsteuerbetrag}">
${positionenXml}
    </MWST-Gruppe>`;
		})
		.join("\n");

	const laborIdAttr = rechnung.laborId
		? ` Labor-ID="${escapeXml(rechnung.laborId)}"`
		: "";

	const xml = `<?xml version="1.0" encoding="UTF-8"?>
<Laborabrechnung Version="4.5">
  <Rechnung Laborname="${escapeXml(
		rechnung.laborname
  )}" Laborsoftware="${escapeXml(
		rechnung.laborsoftware
	)}" Laborsoftwarehersteller="${escapeXml(
		rechnung.laborsoftwarehersteller
	)}" Laborsoftwareversion="${escapeXml(
		rechnung.laborsoftwareversion
	)}"${laborIdAttr} Herstellungsort="${escapeXml(
		rechnung.herstellungsort
	)}" Abrechnungsbereich="${escapeXml(
		rechnung.abrechnungsbereich
	)}" Laborlieferdatum="${escapeXml(
		rechnung.laborlieferdatum
	)}" Laborrechnungsnummer="${escapeXml(
		rechnung.laborrechnungsnummer
	)}" Auftragsnummer="${escapeXml(
		rechnung.auftragsnummer
	)}" Gesamtbetrag_netto="${
		rechnung.gesamtbetrag_netto
	}" Mehrwertsteuer_gesamt="${
		rechnung.mehrwertsteuer_gesamt
	}" Gesamtbetrag_brutto="${rechnung.gesamtbetrag_brutto}">
${mwstGruppenXml}
  </Rechnung>
</Laborabrechnung>`;

	return xml;
}

export function euroToCent(amount: number): number {
	return Math.round(amount * 100);
}

export function quantityToMilli(qty: number): number {
	return Math.round(qty * 1000);
}

export function vatToPromille(rate: number): number {
	return Math.round(rate * 10);
}

export function truncateDescription(desc: string): string {
	return desc.slice(0, 60);
}
